import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { message, Input, Select, Checkbox, Tabs, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputNumberItem,
  SelectItem,
  cuentaMask,
  TextAreaItem,
  InputItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";

const { Option } = Select;
const { TabPane } = Tabs;

class EditarBanco extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoBancosSat: null,
    todasBancosSat: null,
    objetoCuentaContable: null,
    todasCuentaContable: null,
    objetoMonedas: null,
    todasMonedas: null,
    utilizado: false
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentaContable: res.data });
          this.setState({
            objetoCuentaContable: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "bancosSat/selectBancosSat",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancosSat: res.data });
          this.setState({
            objetoBancosSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.clave + " - " + value.nombreCorto}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post("monedas/selectMonedas", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMonedas: res.data });
          this.setState({
            objetoMonedas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "bancos/datosBanco",
        { empresaId: this.props.empresaId, bancoId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del banco");
        } else {
          if (res.data.utilizado) {
            message.info('No se puede modificar toda la informacion ya quel banco ya fue utilizado')
          }
          this.formRef.current.setFieldsValue({
            ...res.data,
          });
          this.setState({
            utilizado: res.data.utilizado,
          })
        }
      });
    this.setState({ loading: false });
  }
  cerrarEditarBanco(codigo) {
    this.props.cerrarEditarBanco(codigo);
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "bancos/editarBanco",
        { ...values, empresaId: this.props.empresaId, bancoId: this.props.id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se edito un banco");
          this.formRef.current.resetFields();
          this.cerrarEditarBanco();
        } else {
          message.error("Sucedio un error y no se edito");
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }

   onChangeBancoSat = (id) => {
    const bancoSeleccionado = this.state.todasBancosSat.find(b => b._id === id);
    
    if (bancoSeleccionado) {

      this.formRef.current.setFieldsValue({
        rfcEmisorCtaBen: bancoSeleccionado.rfc || "",
      });
    }
  }

  render() {
    return (
      <>
        <ModalItem
          title="Editar Banco"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarEditarBanco.bind(this)}
        >
          <Form
            ref={this.formRef}
            name="editarBanco"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Editar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Tabs defaultActiveKey="1">
              <TabPane tab="Información General" key="1">
                <FormItem name="nombre" label="Nombre" required margin pattern>
                  <InputItem placeholder="Nombre" />
                </FormItem>
                <FormItem name="banco" label="Banco" margin pattern required>
                  <InputItem placeholder="Banco" />
                </FormItem>
                <FormItem label="Moneda" name="monedaId" required margin>
                  <SelectItem disabled={this.state.utilizado} placeholder="Moneda">
                    {this.state.objetoMonedas}
                  </SelectItem>
                </FormItem>
                <FormItem label="Banco SAT" name="bancoSatId" required margin>
                  <SelectItem placeholder="Banco SAT" onChange = {this.onChangeBancoSat}>
                    {this.state.objetoBancosSat}
                  </SelectItem>
                </FormItem>
                <FormItem
                  label="Cta Beneficiario"
                  name="ctaBeneficiario"
                  number
                  max={50}
                  min={10}
                  margin
                  tooltip={{ title: "Se puede registrar el número de cuenta en donde se recibió el pago." }}
                >
                  <InputItem placeholder="Cuenta Beneficiario" />
                </FormItem>
                <FormItem
                  label="Rfc Beneficiaria"
                  name="rfcEmisorCtaBen"
                  rfc
                  margin
                  tooltip={{ title: "Se puede registrar la clave en el RFC de la entidad operadora de la cuenta destino, es decir, la operadora, el banco, la institución financiera, emisor de monedero electrónico, etc." }}
                >
                  <InputItem placeholder="Rfc Emisor Cuenta Beneficiaria" />
                </FormItem>
                <FormItem
                  label="Cuenta Clabe"
                  name="cuentaClabe"
                  number
                  max={18}
                  min={18}
                  margin
                >
                  <InputItem placeholder="Cuenta Clabe" />
                </FormItem>
                <FormItem label="Cuenta Contable" margin>
                  <Input.Group compact>
                    <FormItem name="cuentaContableId" required noStyle>
                      <SelectItem placeholder="Cuenta Contable" width="80%" disabled={this.state.utilizado}>
                        {this.state.objetoCuentaContable}
                      </SelectItem>
                    </FormItem>
                    <ButtonItem
                      disabled={this.state.utilizado}
                      icon={<PlusOutlined />}
                      style={{ width: "20%" }}
                      onClick={this.abrirAgregarCuentaContable.bind(this)}
                    />
                  </Input.Group>
                </FormItem>
                <FormItem
                  number
                  margin
                  label="Consecutivo Cheque"
                  name="consecutivoCheque"
                >
                  <InputNumberItem placeholder="Consecutivo Cheque" />
                </FormItem>
                <FormItem
                  label="Es inversion"
                  name="inversion"
                  margin
                  valuePropName="checked"
                  initialValue={false}
                >
                  <Checkbox></Checkbox>
                </FormItem>
                <FormItem
                  name="observaciones"
                  label="Observaciones"
                  margin
                  pattern
                >
                  <TextAreaItem placeholder="Observaciones" />
                </FormItem>
              </TabPane>
              <TabPane tab="Comisiones" key="2">
                <div style={{ marginBottom: 12, color: "#888", fontSize: 12 }}>
                  Arma paquetes de comisión: la comisión y su IVA van como dos renglones del mismo paquete. Al pagar una factura por este banco se elige qué paquetes aplicar, y los renglones de un paquete siempre se generan juntos.
                </div>
                <Form.List name="paquetesComision">
                  {(paquetes, { add: agregarPaquete, remove: quitarPaquete }) => (
                    <>
                      {paquetes.map(({ key: keyPaquete, name: namePaquete, ...restFieldPaquete }) => (
                        <div
                          key={keyPaquete}
                          style={{ border: "1px solid #f0f0f0", borderRadius: 4, padding: 12, marginBottom: 12 }}
                        >
                          <Row gutter={12}>
                            <Col span={23}>
                              <FormItem {...restFieldPaquete} name={[namePaquete, "nombre"]} label="Paquete" required margin pattern>
                                <InputItem placeholder="Nombre del paquete (ej. Transferencia SPEI)" />
                              </FormItem>
                            </Col>
                            <Col span={1} style={{ display: "flex", alignItems: "center", paddingTop: 8 }}>
                              <MinusCircleOutlined
                                style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                                onClick={() => quitarPaquete(namePaquete)}
                              />
                            </Col>
                          </Row>
                          <Form.List
                            name={[namePaquete, "comisiones"]}
                            rules={[
                              {
                                validator: async (_, comisiones) => {
                                  if (!comisiones || comisiones.length < 1) {
                                    return Promise.reject(new Error("Agrega al menos una comisión al paquete"));
                                  }
                                },
                              },
                            ]}
                          >
                            {(comisiones, { add: agregarComision, remove: quitarComision }, { errors }) => (
                              <>
                                {comisiones.map(({ key, name, ...restField }) => (
                                  <Row key={key} gutter={12}>
                                    <Col span={10}>
                                      <FormItem {...restField} name={[name, "proveedorId"]} label="Proveedor" required margin>
                                        <SelectProveedoresItem
                                          empresaId={this.props.empresaId}
                                          headersToken={this.props.headersToken}
                                          placeholder="Proveedor"
                                          width="100%"
                                        />
                                      </FormItem>
                                    </Col>
                                    <Col span={7}>
                                      <FormItem {...restField} name={[name, "monto"]} label="Monto" required margin number>
                                        <InputNumberItem placeholder="Monto" style={{ width: "100%" }} />
                                      </FormItem>
                                    </Col>
                                    <Col span={6}>
                                      <FormItem {...restField} name={[name, "concepto"]} label="Concepto" margin>
                                        <InputItem placeholder="Concepto (opcional)" />
                                      </FormItem>
                                    </Col>
                                    <Col span={1} style={{ display: "flex", alignItems: "center", paddingTop: 8 }}>
                                      <MinusCircleOutlined
                                        style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                                        onClick={() => quitarComision(name)}
                                      />
                                    </Col>
                                  </Row>
                                ))}
                                <ButtonItem type="dashed" onClick={() => agregarComision()} block icon={<PlusOutlined />}>
                                  Agregar comisión
                                </ButtonItem>
                                <Form.ErrorList errors={errors} />
                              </>
                            )}
                          </Form.List>
                        </div>
                      ))}
                      <ButtonItem type="dashed" onClick={() => agregarPaquete({ comisiones: [{}] })} block icon={<PlusOutlined />}>
                        Agregar paquete
                      </ButtonItem>
                    </>
                  )}
                </Form.List>
              </TabPane>
            </Tabs>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarBanco);
